import { IntlProvider } from 'react-intl';
import { setLocale } from 'yup';
import * as Yup from 'yup';
import messages from './../../../i18n/base-en';

const getValidationSchema = (intlData: IntlProvider.Props) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  setLocale({
    mixed: {
      required: formatMessage(messages.required_valid_error)
    },
    string: {
      email: formatMessage(messages.email_valid_error)
    }
  });

  const account = Yup.object().shape({
    firstName: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    lastName: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    email: Yup.string()
      .email()
      .required(),
    address1: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    address2: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true }),
    city: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    country: Yup.string()
      .required(),
    state: Yup.string().when('$isStateFieldMounted', {
      is: (isStateFieldMounted: boolean) => isStateFieldMounted,
      then: Yup.string().required(),
      otherwise: Yup.string(),
    }),
    phoneNumber: Yup.string()
      .matches(/^[^a-zA-Z]*$/, formatMessage(messages.phone_valid_error))
      .matches(/^.{6,}$/, { message: formatMessage(messages.min_length_error, { min: 6 }), excludeEmptyString: true })
      .required(),
    zipCode: Yup.string()
      .matches(/^.{2,}$/, { message: formatMessage(messages.min_length_error,
        { min: 2 }), excludeEmptyString: true })
      .required(),
    physicalStore: Yup.string().when('$isPhisicalStoreMounted', {
      is: (isPhisicalStoreMounted: boolean) => isPhisicalStoreMounted,
      then: Yup.string().required(),
      otherwise: Yup.string(),
    }),
  });

  return Yup.object().shape({ account });

};

export default getValidationSchema;
